import { faArrowCircleUp, faArrowUp, faBars, faChevronDown, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Checkbox } from "primereact/checkbox";
import { InputText } from "primereact/inputtext";
import React,{  useMemo, useState, useRef, useCallback, useEffect } from "react";
import { swalAlert } from "../../services/functions";
import { useTranslation } from "react-i18next";
import { Button } from "primereact/button";
import TooltipOverlay from "../global/TooltipOverlay";

export const MyMultiSelect = ({columns,newColumns, currentColumns, selectedColumns,setSelectedColumns,onChange, }) => {
    const [isOpen, setIsOpen] = useState(false)
    const [search,setSearch]=useState("")
    const { t } = useTranslation('translations');
    const scrollContainerRef = useRef(null);


    const onItemChange=({item,value})=>{
      onChange()
      if(item?.newCol){
          const newItem={show:value,field:item.field}
          if(item.persisted) newItem.persisted=true
          setSelectedColumns((selectedColumns)=>([...selectedColumns,newItem]))
        }else {
          setSelectedColumns(selectedColumns=>{
            return selectedColumns.map(sCol=>{
                if(sCol.field===item.field){
                    let newItem={show:value,field:item.field,...(sCol.width ? {width:sCol.width} : {})}
                    if(item.persisted) newItem.persisted=true
                    return newItem
                }
                return sCol
                })
        })
        }
    }

    const moveToTop = (item) => {
      setSelectedColumns(selectedColumns => {
          const existing = selectedColumns.find(col => col.field === item.field);
          const filteredColumns = selectedColumns.filter(col => col.field !== item.field);
          return [{ show: item.show, field: item.field, ...(item.persisted ? { persisted: true } : {}), ...(existing?.width ? { width: existing.width } : {}) }, ...filteredColumns];
      });
  };

  const DragComponent = React.memo(({ item, newItem, dragOverId }) => {

    const checked = (newItem ? false : (item.persisted || item.show));
    const disabled = newItem ? false : item.persisted;
    return (
        <div className={`my-dropdown-menu-item ${item.field === dragOverId ? "drag-border" : ""}`}>
            <div className="checkbox-label" style={{ cursor: !disabled ? "pointer" : "auto" }}>
                <div className="checkbox">
                    <Checkbox id={item.field} checked={checked} onChange={(e) => { onItemChange({ item, value: e.target.checked }) }} disabled={disabled} />
                </div>
                <div className="label" htmlFor={item.field} onClick={(e) => { if (!disabled) onItemChange({ item, value: !checked }) }}>
                    {item.header}
                </div>
            </div>
            {!newItem?  (
                <div className="column-actions">
                    {newColumns && search?.length === 0 ? <FontAwesomeIcon icon={faBars} style={{ cursor: "pointer", fontSize: "18px" }} /> : null}
                    <TooltipOverlay title={t("table.moveTop")} placement="left">
                        <FontAwesomeIcon icon={faArrowCircleUp} style={{ cursor: "pointer", fontSize: "18px" }} onClick={() => moveToTop(item)} />
                    </TooltipOverlay>
                </div>
            ):<>
            <div className="new-column-badge">New</div>
            </>}
        </div>
    );
  });


    const value=useMemo(()=>currentColumns.filter(currCol=>currCol.show || currCol.persisted).map(item=>item.header).join(","),[currentColumns])
    const newColumnsFiltered =useMemo(()=>{return search?.length>0?newColumns.filter(col=>(col?.header ?? "")?.toLowerCase().includes(search.toLocaleLowerCase())):newColumns},[search,newColumns])
    const currentColumnsFiltered =useMemo(()=>{return search?.length>0?currentColumns.filter(col=>(col?.header ?? "")?.toLowerCase().includes(search.toLocaleLowerCase())):currentColumns},[search,currentColumns])
    const allColumns=useMemo(()=>newColumns.concat(currentColumns),[newColumns,currentColumns])
    const checked=useMemo(()=>allColumns.every(col=>col.show ||col.persisted),[allColumns])

    const onSelectAll=(value)=>{
      setSelectedColumns((prev)=>{
        return allColumns.map(col=>{
          const existing = prev?.find(p => p.field === col.field);
          let item = {show:value?true:(col.default || col.persisted),field:col.field,...(existing?.width ? {width:existing.width} : {})}
          if(col.persisted) item.persisted=true
          return item
        })
      })
    }

    const resetColumns=async ()=>{
      const res = await swalAlert({title:t("common.resetColumnsConfirm"),text:t("common.resetToDefaultColumns"),t})
      if(res){
        setSelectedColumns(()=>{
          return columns.map((col) => ({field:col.field,show:!!col.default,...(col?.persisted?{persisted:true}:{})}))
        })
      }

    }

    return (
      <>
      {isOpen && <div className="my-dropdown-layover" onClick={()=>setIsOpen(false)} />}
        <div className="my-dropdown" >
          <div className="my-dropdown-toggle" onClick={() => setIsOpen((open) => !open)}>
            <div className="selected-values">
              {value}
            </div>
              <FontAwesomeIcon icon={faChevronDown} />
          </div>
          <div className={`my-dropdown-menu`} style={{display:isOpen?"block":"none"}} ref={scrollContainerRef}>
            <div className="my-dropdown-header">
              <Checkbox checked={checked} onChange={(e)=>onSelectAll(e.target.checked)}/>
              <InputText className="my-dropdown-search" type="text" value={search} onChange={(e)=>setSearch(e.target.value)}/>
              <FontAwesomeIcon className="menu-close-button"  icon={faTimes} onClick={()=>setIsOpen(false)}/>
            </div>
            <div className="my-dropdown-body">
            {newColumnsFiltered.map(newCol=><DragComponent item={newCol} newItem={true}/>)}
            <SortableList
                items={currentColumnsFiltered}
                setItems={setSelectedColumns}
                component={DragComponent}
                draggable={search?.length===0}
                onReorder={onChange}
                scrollContainerRef={scrollContainerRef}
            />
            </div>
            <div className="my-dropdown-footer">
              <div className="footer-actions" onClick={resetColumns}>Reset</div>
            </div>
          </div>
        </div>
      </>
    )
  }


  const SortableList = ({ items, setItems, component,key="field",draggable=true,onReorder,scrollContainerRef,...props }) => {
    const [dragId, setDragId] = useState("");
    const [dragOverId,setDragOverId]=useState("")
    const [droppedId, setDroppedId] = useState("");
    const scrollIntervalRef = useRef(null);
    const itemBoundsRef = useRef([]);
    const SCROLL_THRESHOLD = 120;
    const BASE_SCROLL_SPEED = 10;
    const MAX_SCROLL_SPEED = 50;
    const currentScrollSpeedRef = useRef(BASE_SCROLL_SPEED);
    const lastHoverTimeRef = useRef(0);
    const HOVER_THROTTLE = 40;

    const arrayMove=(arr, oldIndex, newIndex)=> {
        if (newIndex >= arr.length) {
          let k = newIndex - arr.length + 1;
          while (k--) {
            arr.push(undefined);
          }
        }

        arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);

        return arr;
      }

    const stopAutoScroll = useCallback(() => {
      if (scrollIntervalRef.current) {
        cancelAnimationFrame(scrollIntervalRef.current);
        scrollIntervalRef.current = null;
      }
    }, []);

    const startAutoScroll = useCallback((direction, speed) => {
      stopAutoScroll();
      currentScrollSpeedRef.current = speed;
      const scroll = () => {
        if (scrollContainerRef?.current) {
          scrollContainerRef.current.scrollTop += direction * currentScrollSpeedRef.current;
          scrollIntervalRef.current = requestAnimationFrame(scroll);
        }
      };
      scrollIntervalRef.current = requestAnimationFrame(scroll);
    }, [scrollContainerRef, stopAutoScroll]);

    const throttledSetDragOverId = useCallback(
      throttle((id) => {
        setDragOverId(id);
      }, 20),
      []
    );

    const getHoveredItemId = (mouseY, scrollTop) => {
      for (let i = 0; i < itemBoundsRef.current.length; i++) {
        const { top, bottom, id } = itemBoundsRef.current[i];
        if (mouseY >= (top - scrollTop) && mouseY <= (bottom - scrollTop)) {
          return id;
        }
      }
      return null;
    };

    const handleContainerDragOver = useCallback((ev) => {
      ev.preventDefault();
      if (!scrollContainerRef?.current) return;

      const now = Date.now();
      if (now - lastHoverTimeRef.current < HOVER_THROTTLE) return;
      lastHoverTimeRef.current = now;

      const container = scrollContainerRef.current;
      const rect = container.getBoundingClientRect();
      const mouseY = ev.clientY;
      const scrollTop = container.scrollTop;

      const distanceFromTop = mouseY - rect.top;
      const distanceFromBottom = rect.bottom - mouseY;
      const isAboveContainer = mouseY < rect.top;
      const isBelowContainer = mouseY > rect.bottom;

      let scrollSpeed = BASE_SCROLL_SPEED;

      if ((distanceFromTop < SCROLL_THRESHOLD || isAboveContainer) && container.scrollTop > 0) {
        if (isAboveContainer) {
          const distanceOutside = rect.top - mouseY;
          const speedMultiplier = Math.min(distanceOutside / SCROLL_THRESHOLD, 1);
          scrollSpeed = BASE_SCROLL_SPEED + (MAX_SCROLL_SPEED - BASE_SCROLL_SPEED) * speedMultiplier;
        } else {
          const distanceRatio = 1 - (distanceFromTop / SCROLL_THRESHOLD);
          scrollSpeed = BASE_SCROLL_SPEED + (MAX_SCROLL_SPEED - BASE_SCROLL_SPEED) * distanceRatio * 0.5;
        }
        startAutoScroll(-1, scrollSpeed);
      } else if ((distanceFromBottom < SCROLL_THRESHOLD || isBelowContainer) && container.scrollTop < container.scrollHeight - container.clientHeight) {
        if (isBelowContainer) {
          const distanceOutside = mouseY - rect.bottom;
          const speedMultiplier = Math.min(distanceOutside / SCROLL_THRESHOLD, 1);
          scrollSpeed = BASE_SCROLL_SPEED + (MAX_SCROLL_SPEED - BASE_SCROLL_SPEED) * speedMultiplier;
        } else {
          const distanceRatio = 1 - (distanceFromBottom / SCROLL_THRESHOLD);
          scrollSpeed = BASE_SCROLL_SPEED + (MAX_SCROLL_SPEED - BASE_SCROLL_SPEED) * distanceRatio * 0.5;
        }
        startAutoScroll(1, scrollSpeed);
      } else {
        stopAutoScroll();
      }

      const relativeY = mouseY - rect.top + scrollTop;
      const hoveredId = getHoveredItemId(relativeY, 0);
      if (hoveredId && hoveredId !== dragId && hoveredId !== dragOverId) {
        throttledSetDragOverId(hoveredId);
      }
    }, [scrollContainerRef, startAutoScroll, stopAutoScroll, dragId, dragOverId, throttledSetDragOverId]);

    useEffect(() => {
      if (scrollContainerRef.current && items.length > 0) {
        const draggables = scrollContainerRef.current.querySelectorAll('.draggable-item');
        itemBoundsRef.current = Array.from(draggables).map(el => ({
          id: el.id,
          top: el.offsetTop,
          bottom: el.offsetTop + el.offsetHeight
        }));
      }
    }, [items, dragId]);

    useEffect(() => {
      return () => stopAutoScroll();
    }, [stopAutoScroll]);

    const onDrop = (ev, item) => {
      stopAutoScroll();
      let currentPos = 0,
        droppedPos = 0;

      for (let i = 0; i < items.length; i++) {
        if (dragId == items[i][key]) {
          currentPos = i;
        }

        if (ev.currentTarget.id == items[i][key]) {
          droppedPos = i;
        }
      }

      let adjustedDropPos = droppedPos;
      if (currentPos < droppedPos) {
        adjustedDropPos = droppedPos - 1;
      }

      const droppedItemId = dragId;
      const newItems = arrayMove([...items], currentPos, adjustedDropPos);
      setItems((prev) => {
        const prevList = Array.isArray(prev) ? prev : [];
        const mappedItems = newItems.map(item => {
          const existing = prevList.find(p => p.field === item.field);
          return {
            show: item.show,
            field: item.field,
            ...(item.persisted ? { persisted: true } : {}),
            ...(existing?.width ? { width: existing.width } : {})
          };
        });
        const reorderedFields = new Set(mappedItems.map(item => item.field));
        return mappedItems.concat(prevList.filter(p => !reorderedFields.has(p.field)));
      });
      setDragOverId("");
      setDragId("");
      setDroppedId(droppedItemId);

      setTimeout(() => {
        setDroppedId("");
        if (scrollContainerRef?.current) {
          scrollContainerRef.current.classList.add('drop-cooldown');
          setTimeout(() => {
            if (scrollContainerRef.current) {
              scrollContainerRef.current.classList.remove('drop-cooldown');
            }
          }, 300);
        }
      }, 0);

      if (onReorder) {
        setTimeout(onReorder, 0);
      }
    };

    const onDragStart = (ev, item) => {
      setDragId(item[key]);
    };

    const onDragEnter = (ev, item) => {
      ev.preventDefault();
      if (item[key] !== dragId && item[key] !== dragOverId) {
        throttledSetDragOverId(item[key]);
      }
    };

    const onDragEnd = () => {
      stopAutoScroll();
      setDragId("");
      setDragOverId("");
      throttledSetDragOverId.cancel();
    };

    const renderComponent = ({componentJsx, item, index, dragOverId, isDragging}) => {
      const Component = componentJsx;

      return <Component item={item} index={index} dragOverId={dragOverId} isDragging={isDragging}/>;
    };

    return (
      <div onDragOver={handleContainerDragOver}>
        {items.map((item, index) => {
          const isDragging = dragId === item[key];
          const isOver = dragOverId === item[key];
          const justDropped = droppedId === item[key];
          return <Draggable
            key={index}
            draggable={draggable}
            id={item?.id ?? item?.[key]}
            onDrop={onDrop}
            onDragStart={onDragStart}
            onDragEnter={onDragEnter}
            onDragEnd={onDragEnd}
            item={item}
            isDragging={isDragging}
            isOver={isOver}
            justDropped={justDropped}
            {...props}
          >
            {renderComponent({componentJsx:component, item, index, dragOverId, isDragging})}
          </Draggable>
  })}
      </div>
    );
  };

  export const Draggable = React.memo(({
    children,
    id,
    item = {},
    onDragStart = (event, item) => {},
    onDrop = (event, item) => {},
    onDragEnter = (event, item) => {},
    onDragEnd = () => {},
    isDragging = false,
    isOver = false,
    justDropped = false,
    ...props
  }) => {
    const handleDrag = (ev) => {
      onDragStart(ev, item);
    };

    const handleDrop = (ev) => {
      onDrop(ev, item);
    };

    const handleDragEnter = (ev) => {
      onDragEnter(ev, item);
    };

    const handleDragEnd = () => {
      onDragEnd();
    };

    const classNames = [
      "draggable-item",
      isDragging ? "is-dragging" : "",
      isOver ? "drag-over" : "",
      justDropped ? "just-dropped" : ""
    ].filter(Boolean).join(" ");

    return (
      <div
        id={id}
        onDragStart={handleDrag}
        onDrop={handleDrop}
        onDragEnter={handleDragEnter}
        onDragEnd={handleDragEnd}
        className={classNames}
        {...props}
      >
        {children}
      </div>
    );
  });

  function throttle(func, limit) {
    let lastCall = 0;
    const throttled = (...args) => {
      const now = Date.now();
      if (now - lastCall >= limit) {
        lastCall = now;
        func(...args);
      }
    };
    throttled.cancel = () => {};
    return throttled;
  }
